import { GifLoadingop } from "../assets";

export default () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        flexDirection: "column",
        backgroundColor: "#ffff",
      }}
    >
      <img
        loading="eager"
        src={GifLoadingop}
        alt="loading"
        style={{
          width: "100%",
          maxWidth: 150,
        }}
      />
    </div>
  );
};
